module.exports = __webpack_public_path__ + "img/copy-link-h.7e6c384a.svg";